import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const MobileWelcome = () => {
  return (
    <Card style={{ borderRadius: 10 }} bodyStyle={{ padding: 12 }}>
      <Title level={4} style={{ marginTop: 0 }}>欢迎使用</Title>
      <Paragraph style={{ marginBottom: 8 }}>你的账号已审批通过，但当前为普通用户权限。</Paragraph>
      <Paragraph style={{ marginBottom: 0 }}>如需访问管理功能，请使用管理员账号登录。</Paragraph>
    </Card>
  );
};

export default MobileWelcome;
